var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DDTDettaglio',{attrs:{"num_ddt":_vm.num_ddt,"id_ddt":_vm.id_ddt}})
}
var staticRenderFns = []

export { render, staticRenderFns }